import { Grid } from "@mui/material"
import { CustomTabPanel } from "../../../../../components/componentsAnaliseClientes/CustomTabPanel"
import { TabNumberOfSalesItem } from "./item";

export const TabNumberOfSalesChart = ({ data, value }) => {

    return <CustomTabPanel value={value} index={1} style={{ padding: '16px' }}>
        <Grid container spacing={2} rowGap={4}>
            <TabNumberOfSalesItem title="Ano Atual" data={data?.currentYear} />
            <TabNumberOfSalesItem title="Ano Anterior" data={data?.pastYear} />
            <TabNumberOfSalesItem title="Período anterior" data={data?.pastPeriod} />
        </Grid>
    </CustomTabPanel>
}